import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  button: {
    ...theme.buttonOutline,
    backgroundColor: 'unset',
    border: 'unset',
    padding: `${theme.spacing(1)}px 0`,
    ...theme.typography.actionPurpleText,
    display: 'flex',
  },
}));
